import React, { useState } from 'react';
import { CloseButtonSvgIcon } from './IconProvider';
import { useTranslation } from 'react-i18next';
import configService from '../../services/config.service';
const KycTermsCondition = ({ modelClose, setKycModal }) => {
  const [isAgree, setIsAgree] = useState(false);
  const { t } = useTranslation(['onfidoKyc', 'common']);
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto mx-3 my-4 max-w-3xl ">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full dark:bg-slate-800  dark:text-slate-200  bg-white outline-none focus:outline-none md:w-[512px] md:min-w-[512px] ">
            {/*header*/}
            <button
              className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
              onClick={() => modelClose(false)}
            >
              <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
                <CloseButtonSvgIcon />
              </span>
            </button>
            {/*body*/}

            <div className="p-10">
              <div>
                <h3 className="text-3xl font-medium mb-4">
                  {t('common:complete_kyc')}
                </h3>
                <p className="mb-6">{t('next_steps_info')} </p>
                <p className="mb-6">
                  {t('compliance_info', {
                    appName: configService.appName(),
                  })}
                </p>
                <p className="mb-6">{t('privacy_notice_info')}</p>
                <p className="mb-6">
                  <a
                    href="https://www.energyblocks.nl/privacy-verklaring"
                    target="_blank"
                    rel="noreferrer"
                    className="bg-brandBlue pt-3 pb-3 text-white text-md font-semibold rounded-md px-5 leading-normal py-2 text-center hover:bg-brandBlue focus:bg-brandBlue hover:transition-all mt-6"
                  >
                    {t('open_privacy_notice')}
                  </a>
                </p>
                <div className="flex items-center mt-12 justify-between w-full">
                  <div className="flex items-center">
                    <input
                      id="default-checkbox"
                      type="checkbox"
                      onChange={(e) => setIsAgree(e.target.checked)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      htmlFor="default-checkbox"
                      className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                      {t('common:i_accept')}
                    </label>
                  </div>

                  <div>
                    <button
                      disabled={!isAgree}
                      onClick={() => {
                        setKycModal(true);
                        modelClose(false);
                      }}
                      className="kyc bg-[#A7D760] text-[#0B243F] text-md font-semibold rounded-md px-5 leading-normal py-2 text-center hover:bg-[#97C05B] focus:bg-[#A7D760] hover:transition-all"
                    >
                      {t('common:continue')}
                    </button>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default KycTermsCondition;
